var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyrac(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000047035657605103983350000006977344711327270310_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 648.6 162.5",
    style: {
      enableBackground: "new 0 0 648.6 162.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F95108;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000132067818919960405690000003099901949833243052_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,27.8C0,11.1,9.7,3.5,22.3,3.5c8,0,14.6,3.3,18.5,9.6c3.8-6.3,10.4-9.6,18.5-9.6c12.6,0,22.3,7.6,22.3,24.3 v30.4H68.8V27.8c0-8.7-4.5-12.3-10.8-12.3s-10.7,3.7-10.7,12.3v30.4H34.4V27.8c0-8.6-4.6-12.3-10.8-12.3s-10.8,3.6-10.8,12.3v30.4 H0V27.8L0,27.8z M92.6,64.1h12.8c2.2,5,6.4,7.2,12.8,7.2c8.7,0,13.7-4.2,13.7-14.6V50c-3.2,5.8-8.8,9-15.9,9c-12.3,0-24-8-24-27 V4.9H105V32c0,10.2,5.4,15,13.5,15S132,41.9,132,32V4.9h12.8v51.5c0,18.6-11.8,26-26.6,26C105.9,82.4,95.6,76.7,92.6,64.1 L92.6,64.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.5126,
    y1: -86.2819,
    x2: 506.3925,
    y2: 246.0679,
    gradientTransform: "matrix(1 0 0 -1 0 164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8E007D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#BF099E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#DD5113"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DD5113"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.1,81.4h-55.1c-2.2,0-2.7,1-2.7,1.9c0,0.7,0.5,1.5,1,1.7l86.5,56l-13.6,21.4l-80.9-53.3 c-10.2-6.8-18-13.2-18-26.3c0-14.9,10.7-25.1,30.2-25.1h52.4c8,0,8-6.6,8-9V32.4c0-2.4,0-9-8-9h-86.2c-8.1,0-8.1,6.6-8.1,9v130.1 h-25.1V33.6c0-25.8,19-33.6,33.1-33.6h87c14.1,0,31.9,6.6,31.9,32.4v16.1C314.6,74.3,296.3,81.4,282.1,81.4 M447.2,162.5h-86 c-14.1,0-32.7-7.3-32.7-33.1V90.1c0-25.8,19-33.6,33.1-33.6h92.8V33.6c0-2.4,0-9-8-9H340.9V0h106.5c14.1,0,32.7,7.3,32.7,33.1v96 C480.1,155,461.3,162.5,447.2,162.5 M454.5,80.9h-93.1c-8,0-8,6.6-8,9v39.2c0,2.4,0,9,8,9h85c8,0,8-6.6,8-9L454.5,80.9L454.5,80.9z  M534,162.5c-14.1,0-32.6-7.3-32.6-33.1V33.6c0-25.8,19-33.6,33.1-33.6h114v24.6H535.5c-8,0-8,6.6-8,9v95.3c0,2.4,0,9,8,9h113.1 v24.6L534,162.5L534,162.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121964109305919112180000011022413445497209018_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.5126,
    y1: -86.2819,
    x2: 506.3925,
    y2: 246.0679,
    gradientTransform: "matrix(1 0 0 -1 0 164)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90007E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#C109A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F95108"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F95108"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121964109305919112180000011022413445497209018_)"
    },
    d: "M282.1,81.4h-55.1c-2.2,0-2.7,1-2.7,1.9 c0,0.7,0.5,1.5,1,1.7l86.5,56l-13.6,21.4l-80.9-53.3c-10.2-6.8-18-13.2-18-26.3c0-14.9,10.7-25.1,30.2-25.1h52.4c8,0,8-6.6,8-9 V32.4c0-2.4,0-9-8-9h-86.2c-8.1,0-8.1,6.6-8.1,9v130.1h-25.1V33.6c0-25.8,19-33.6,33.1-33.6h87c14.1,0,31.9,6.6,31.9,32.4v16.1 C314.6,74.3,296.3,81.4,282.1,81.4 M447.2,162.5h-86c-14.1,0-32.7-7.3-32.7-33.1V90.1c0-25.8,19-33.6,33.1-33.6h92.8V33.6 c0-2.4,0-9-8-9H340.9V0h106.5c14.1,0,32.7,7.3,32.7,33.1v96C480.1,155,461.3,162.5,447.2,162.5 M454.5,80.9h-93.1c-8,0-8,6.6-8,9 v39.2c0,2.4,0,9,8,9h85c8,0,8-6.6,8-9L454.5,80.9L454.5,80.9z M534,162.5c-14.1,0-32.6-7.3-32.6-33.1V33.6 c0-25.8,19-33.6,33.1-33.6h114v24.6H535.5c-8,0-8,6.6-8,9v95.3c0,2.4,0,9,8,9h113.1v24.6L534,162.5L534,162.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyrac);
export default __webpack_public_path__ + "static/media/myrac.7472b6fb78863110eb537be26f3cd043.svg";
export { ForwardRef as ReactComponent };